import { EventBus } from "@/libs/EventBus"
import { Equipment } from "@/services/project/equipment/equipment.model"
import { Node } from "@antv/x6"

interface NozzleEdgeProps {
  width: number
  height: number
  nozzleEdge: Equipment.NozzleEdge
  eventBus: EventBus
  node: Node
}
export const NozzleEdge = (props: NozzleEdgeProps) => {
  const { nozzleEdge, width, height, eventBus, node } = props
  const {start, end} = nozzleEdge
  const startPoint = {x: width * start.x, y: start.y * height}
  const endPoint = {x: width * end.x, y: end.y * height}
  
  const dx = endPoint.x - startPoint.x
  const dy = endPoint.y - startPoint.y
  const length = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2))
  if (startPoint.y + 1 > height) {
    startPoint.y -= 1;
  }
  if (startPoint.y === 0) {
    startPoint.y -= 1;
  }

  if (startPoint.x + 1 > width) {
    startPoint.x -= 1;
  }

  let angle = Math.round(Math.acos(dx/length)*180/Math.PI)

  const styles = {
    transform: `rotate(${angle}deg)`,
    transformOrigin: 'left center',
    width: length,
    left: startPoint.x,
    top: startPoint.y,
  }
  return <div
    onMouseDown={(e) => {
      e.nativeEvent.stopPropagation()
      e.nativeEvent.preventDefault()
      eventBus.trigger('node:nozzleEdge:mousedown', {e: e.nativeEvent, nozzleEdge, node})
    }}
    onMouseUp={(e) => {
      eventBus.trigger('node:nozzleEdge:mouseup', {e: e.nativeEvent, nozzleEdge, node})
    }} className="nozzle-edge" style={styles as any}></div>
}